import { useSelector } from "react-redux";

const PlanHistoryModal = ({ closeModal }) => {
    const { userPlanHistory } = useSelector((state) => state.subscription);
    return (
        <div className="container" style={{ maxHeight: "80vh", overflow: "auto" }}>
            <div className="row">
                <div className="col-md-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Plan Name</th>
                                <th scope="col">Type</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userPlanHistory && userPlanHistory.length > 0 ?
                                userPlanHistory.map((item, i) =>
                                    <tr>
                                        <th scope="row">{i + 1}</th>
                                        <td>{item.subscription_name}</td>
                                        <td>{item.subscription_name === "Free" ? "--" : item.plan_type}</td>
                                        <td>{item.start_date}</td>
                                        <td>{item.end_date}</td>
                                    </tr>) : <tr>
                                    <td colSpan={5}>No Data Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PlanHistoryModal;